/**
 * Stellaj temirining ranglari.
 *
 * Bular dizayn TOKENI EMAS va tema bilan o'zgarmaydi — bu bo'yoqning
 * o'zi. Qarshi omboridagi stellaj ko'k ramali va orange balkali; ekranda
 * ham aynan shunday ko'rinishi kerak, aks holda odam ekrandagi javonni
 * ombordagi javon bilan bog'lay olmaydi.
 */
/** Stellaj temirining turlari — 3D ham, fasad ham shu ro'yxatga tayanadi. */
export type RackPartKind = 'post' | 'beam' | 'brace' | 'deck' | 'pad' | 'mark';

export const RACK_COLORS: Record<RackPartKind, string> = {
  post: '#1c4fa1',
  beam: '#e2661c',
  brace: '#17418a',
  /* Taxta lapachka — temir emas, yog'och. Balkalar ustiga yotqiziladi va
     mahsulot aynan shunga qo'yiladi. Ilgari chizilmasdi va javon ochiq
     ramka bo'lib ko'rinardi: qatorlar bor edi, lekin ular ustida turadigan
     tekislik yo'q edi. */
  deck: '#c08d55',
  /* OCHIQ MAYDON — beton maydoncha va unga chizilgan sariq chiziq.
     Maydonda temir yo'q: uni ko'rsatadigan yagona narsa — bo'yoq. */
  pad: '#9a9a96',
  mark: '#f2c230',
};
